import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","height":"100%"},
  class: "overflow-auto px-16px pt-16px pb-16px"
}
const _hoisted_2 = { class: "search flex items-center gap-4px" }
const _hoisted_3 = {
  class: "menu-list grid grid-cols-4 gap-12px",
  style: {"gap":"12px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "recommend-list" }
const _hoisted_6 = {
  key: 0,
  class: "title flex items-center justify-between mt-[32px] mb-[16px]"
}
const _hoisted_7 = { class: "text-ellipsis whitespace-nowrap overflow-hidden font-bold" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "imageList" }
const _hoisted_10 = {
  key: 0,
  class: "element-list"
}

import { onMounted, ref } from 'vue'
import { ElInput, ElButton, ElCascader } from 'element-plus'
import { ArrowDown, Search } from '@element-plus/icons-vue'
import { getCategories, recommendations, gettagMaterials } from '@/api/affairs'
// @ts-ignore
import elementItem from './elementItem.vue'
// @ts-ignore
import elementlist from './elementlist.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'material',
  props: {
    type: {}
  },
  setup(__props: any) {

const menuList = ref([])
const recommendList = ref([])
const props = __props
const searchValue = ref('')
const handleSearch = () => {

}
const elementListShow = ref(false)
const categoriesElementList = ref([])
const searchShow = ref(true)
const categoriesShow = ref(true)
const List = ref([])



onMounted(() => {
  getCategories({ category_type: 2, size: 20, type: props.type == 'team' ? 2 : 1 }).then(res => {
    menuList.value = res.data.data
  })
  getList()
})
const handleCategoryClick = (item) => {
  categoriesElementList.value = item
  searchShow.value = true
  categoriesShow.value = true
  elementListShow.value = true
  console.log(item)
}
const getList = () => {
  gettagMaterials({ key: 'scene', hot_type: 2, page: 1, size: 20, }).then((res) => {
    const data = res.data.data.categories[0].children
    console.log('data---', data
    )
    recommendList.value = data
  })
}
const handleMoreClick = (item) => {
  searchShow.value = false
  categoriesShow.value = false
  elementListShow.value = true
  // console.log(item)
  List.value = item
}
const getimage = (val) => {
  return val.slice(0, 3)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElInput), {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
          placeholder: "请输入搜索内容",
          clearable: "",
          "prefix-icon": _unref(Search),
          style: {"margin-right":"16px"}
        }, null, 8, ["modelValue", "prefix-icon"]),
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: handleSearch,
          style: {"background-color":"#2a66ff"}
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("搜索", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            onClick: ($event: any) => (handleCategoryClick(item)),
            class: "menu-item",
            style: _normalizeStyle({ 'backgroundImage': `url(${item.cover_image})` })
          }, null, 12, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            (item.materials.list.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: "more cursor-pointer",
                    onClick: ($event: any) => (handleMoreClick(item))
                  }, " 更多", 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getimage(item.materials.list), (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "w-[33%] h-[80px] rounded-md overflow-hidden"
                }, [
                  _createVNode(elementItem, { template: img }, null, 8, ["template"])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, elementListShow.value == false]
    ]),
    (elementListShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(elementlist, {
            categoriesElementList: categoriesElementList.value,
            categoriesShow: categoriesShow.value,
            searchShow: searchShow.value,
            onBack: _cache[1] || (_cache[1] = ($event: any) => (elementListShow.value = false)),
            list: List.value
          }, null, 8, ["categoriesElementList", "categoriesShow", "searchShow", "list"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})